import React, { Component } from 'react';
import '../../App.css';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import { Menu, Icon } from 'semantic-ui-react';
import { loggedIn } from '../../modules/user';
import { toggleAppSidebar } from '../../modules/app';

import { appUtil, featureToggleUtil } from '../../utils';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import BetaReaderLogoAndName from '../../components/svg/BetaReaderLogoAndName';

const Left = styled.div`
  text-align: left;
`;

export class AppMenu extends Component {
  unsubScribeHistoryListener;

  constructor(props) {
    super(props);
    this.state = {};
    this.unsubScribeHistoryListener = props.history.listen(() => {
      // close submenu if changing location in small screen mode
      if (appUtil.isSmallScreen()) {
        this.setState({
          showSubMenu: false,
        });
      }
    });
  }

  componentWillUnmount() {
    this.unsubScribeHistoryListener();
  }

  handlePageClick = (e, { name }) => {
    // if we are on a small screen, close side bar after menu selection
    if (window && window.innerWidth && window.innerWidth < 768) {
      this.props.toggleAppSidebar(false);
    }
    this.props.changePage(`/${name}`);
  };

  openInNewWindow = url => {
    window.open(url, 'betareader.io_reader');
  };

  isOnPath = name => {
    const { location } = this.props;
    return location && location.pathname.startsWith(name);
  };

  showSubMenu = menu => {
    this.setState({
      showSubMenu: menu,
    });
  };

  shouldShowSubMenu = menu => {
    const { showSubMenu } = this.state;
    const isActive = showSubMenu === menu;
    if (!isActive) {
      return this.isOnPath(`/${menu}`);
    }
    return isActive;
  };

  render() {
    const { userProfile, t, critiqueGroupsEnabled } = this.props;
    return [
      <Menu.Item key="about" content={<BetaReaderLogoAndName />} />,
      userProfile && (
        <Menu.Item
          position="left"
          key="mymanuscripts"
          name="mymanuscripts"
          active={this.isOnPath('/mymanuscripts')}
          onClick={this.handlePageClick}
          content={
            <Left>
              <Icon name="book" /> {t('MyManuscripts')}
            </Left>
          }
        />
      ),
      userProfile && (
        <Menu.Item
          key="readingList"
          name="readinglist"
          active={this.isOnPath('/readinglist')}
          onClick={this.handlePageClick}
          content={
            <Left>
              <Icon name="bookmark" /> {t('ReadingList')}
            </Left>
          }
        />
      ),
      <Menu.Item
        key="discover"
        name="discover"
        active={this.isOnPath('/discover')}
        onClick={this.handlePageClick}
        content={
          <Left>
            <Icon name="search" /> {t('Discover')}
          </Left>
        }
      />,
      <Menu.Item
        key="sample-chapters"
        name="sample-chapters/discover"
        active={
          this.isOnPath('/sample-chapters/discover') ||
          this.isOnPath('/sample-chapters/read')
        }
        onClick={this.handlePageClick}
        content={
          <Left>
            <Icon name="book" /> {t('SampleChaptersBrowse', 'Sample chapters')}
          </Left>
        }
      />,
      <Menu.Item
        key="feed"
        name="feed"
        active={this.isOnPath('/feed')}
        onClick={this.handlePageClick}
        content={
          <Left>
            <Icon name="feed" /> {t('Feed')}
          </Left>
        }
      />,
      userProfile && critiqueGroupsEnabled && (
        <Menu.Item
          key="critique-groups"
          name="critique-groups"
          active={this.isOnPath('/critique-groups')}
          onClick={this.handlePageClick}
          content={
            <Left>
              <Icon name="users" /> {t('CritiqueGroups', 'Critique groups')}
            </Left>
          }
        />
      ),
      userProfile && (
        <Menu.Item
          key="readers"
          name="readers"
          active={this.isOnPath('/readers')}
          onClick={this.handlePageClick}
          content={
            <Left>
              <Icon name="list ul" /> {t('ReaderList')}
            </Left>
          }
        />
      ),
      userProfile && (
        <Menu.Item
          key="inbox"
          name="inbox"
          active={this.isOnPath('/inbox')}
          onClick={this.handlePageClick}
          content={
            <Left>
              <Icon name="chat" /> {t('Chat')}
            </Left>
          }
        />
      ),
    ];
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
  alerts: state.app.alerts,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loggedIn,
      toggleAppSidebar,
      changePage: newPage => push(newPage),
    },
    dispatch
  );

const ConnectedAppMenu = withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AppMenu))
);

// Bridge the critique_groups flag (a hook) into the connected class so the nav
// item stays dark by default. Two-tier like the rest of the app: the global
// flag OR the user's beta grant — the API applies the same OR, so gating on the
// global flag alone would hide the nav from beta users the API would serve.
const AppMenuWithFlags = props => {
  const { flags, isLoading: flagsLoading } = useFeatureFlags();
  const userProfile = useSelector(state => state.user.userProfile);
  const critiqueGroupsEnabled =
    (!flagsLoading && flags?.critique_groups === true) ||
    featureToggleUtil.hasFeatureAccess(userProfile, 'critique_groups');
  return (
    <ConnectedAppMenu {...props} critiqueGroupsEnabled={critiqueGroupsEnabled} />
  );
};

export default AppMenuWithFlags;
